import { RootState } from "modules/shared/infrastructure/redux/auditStore";
import { TypedUseSelectorHook, useSelector } from "react-redux";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
